import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=662e194c&"
import script from "./ChartBar.vue?vue&type=script&lang=js&"
export * from "./ChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports